import axios from "axios";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Container, Row, Col, Modal, Form } from "react-bootstrap";
import { Button, Popup, Checkbox, Divider, Dropdown, Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { DateRangePicker } from "rsuite";
import { Toast } from "../component/Toast";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const MultipleDisc = () => {
    const gridApiRef = useRef(null);

    const session = JSON.parse(localStorage.getItem("cms_session"));
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedRows, setSelectedRows] = useState([]);
    const [ids, setIds] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [search, setSearch] = useState("")
    const [discType, setDiscType] = useState(editData?.disc_type || "1");
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(
        editData?.disc_target || ""
    );
    const [loadingCategory, setLoadingCategory] = useState(false);
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);
    const [selectedId, setSelectedId] = useState('');

    const [dateRange, setDateRange] = useState([
        new Date(moment().startOf("month")),
        new Date(moment()),
    ]);

    const [dateRangeActive, setDateRangeActive] = useState([
        new Date(moment().startOf("month")),
        new Date(moment()),
    ]);

    const categoryOptions = categories.map((cat) => ({
        key: cat.category_name,
        text: cat.category_name,
        value: cat.category_name,
    }));

    const formatDate = (date) =>
        date ? moment(date).format("YYYY-MM-DD") : "";

    const successAlert = (msg) =>
        Toast.fire({ 
            icon: "success", 
            title: msg, 
            position: 'center',
            timer: null,
            timerProgressBar: false,
            showConfirmButton: false,
            showCloseButton: true
        });

    const errorAlert = (msg) =>
        Toast.fire({ icon: "error", 
            title: msg, 
            position: 'center',
            timer: null,
            timerProgressBar: false,
            showConfirmButton: false,
            showCloseButton: true
        });

    const getData = async () => {
        setLoading(true);
        try {
            const res = await axios.get(
                `${global.SRV}api_rudrunner_cms/controler/event.php/`,
                //`http://localhost:8000/controler/event.php`,
                {
                    params: {
                        index: 10,
                        limit: 50,
                        ...(search ? { search } :
                            { "date[]": [formatDate(dateRange[0]), formatDate(dateRange[1])] }),
                    },
                }
            );
            setData(res.data.data || []);
        } catch (err) {
            errorAlert(err.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, [dateRange]);

    useEffect(() => {
        setSelectedCategory("");
    }, [discType]);

    useEffect(() => {
        if (editData) {
            setDiscType(editData.disc_type);
        }
    }, [editData]);

    useEffect(() => {
        if (discType === "0") {
            fetchCategories();
        }
    }, [discType]);

    const fetchCategories = async () => {
        try {
            setLoadingCategory(true);

            const res = await fetch(
                `${global.SRV}api_rudrunner_cms/controler/event.php/?index=11`
                //`http://localhost:8000/controler/event.php/?index=11`,
            );
            const data = await res.json();

            if (data.state === 200) {
                setCategories(data.data);
            }
        } catch (error) {
            console.error("Failed fetch categories", error);
        } finally {
            setLoadingCategory(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete selected data?")) return;
        setIsLoadingDelete(true);

        try {
            await axios.post(
                `${global.SRV}api_rudrunner_cms/controler/event.php/?index=27&id=${id}`,
                //`http://localhost:8000/controler/event.php/?index=27&id=${id}`,
            );
            successAlert("Deleted successfully");
            getData();
        } catch (err) {
            errorAlert(err.response?.data?.message);
        } finally {
            setIsLoadingDelete(false);
        }
    };

    // const handleUpdateStatus = async (id, e) => {
    //     setIsLoadingUpdate(true);
    //     const formData = new FormData(e.target);
    //     try {
    //         await axios.post(
    //             `${global.SRV}api_rudrunner_cms/controler/event.php/?index=26&id=${id}`,
    //             formData
    //         );
    //         successAlert("Status updated");
    //         getData();
    //     } catch (err) {
    //         errorAlert(err.response?.data?.message);
    //     } finally {
    //         setIsLoadingUpdate(false);
    //         setSelectedStatus("");
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (discType === "0" && !selectedCategory) {
            errorAlert("Please select a category");
            return;
        }

        if (discType === "1" && !e.target.disc_target.value.trim()) {
            errorAlert("Please enter product code");
            return;
        }

        setIsLoadingSubmit(true);

        const formData = new FormData(e.target);
        formData.append("start_date", formatDate(dateRangeActive[0]));
        formData.append("end_date", formatDate(dateRangeActive[1]));
        if (editData) formData.append("modifier", session?.name);

        try {
            await axios.post(
                editData
                    ? `${global.SRV}api_rudrunner_cms/controler/event.php/?index=26&id=${editData.id}`
                    : `${global.SRV}api_rudrunner_cms/controler/event.php/?index=25`,
                //editData
                //    ? `http://localhost:8000/controler/event.php/?index=26&id=${editData.id}`
                //    : `http://localhost:8000/controler/event.php/?index=25`,
                formData
            );
            successAlert("Saved successfully");
            setShowModal(false);
            setEditData(null);
            getData();
        } catch (err) {
            errorAlert(err.response?.data?.message);
        } finally {
            setIsLoadingSubmit(false);
        }
    };

    const columnDefs = useMemo(() => [
        { checkboxSelection: true, headerCheckboxSelection: true, maxWidth: 50 },
        { headerName: "Code", field: "disc_code", sortable: true },
        { headerName: "Type", field: "disc_type", valueFormatter: (t) => t.value === "0" ? "CATEGORIES" : "PRODUCT" },
        { headerName: "Target", field: "disc_target" },
        {
            headerName: "Discount %",
            field: "disc_percentage",
            valueFormatter: (p) => `${p.value}%`,
        },
        { headerName: "Max Qty", field: "maximum_qty" },
        {
            headerName: "Active",
            field: "is_active",
            cellRenderer: ({ data }) => (
                <Checkbox
                    toggle
                    disabled={isLoadingStatus}
                    loading={selectedId === data.id}
                    checked={data.is_active === "1"}
                    onChange={async () => {
                        setIsLoadingStatus(true)
                        setSelectedId(data.id)
                        try {
                            const formData = new FormData();
                            const status = data.is_active === "1" ? 0 : 1;
                            formData.append("is_active", status);
                            await axios.post(
                                `${global.SRV}api_rudrunner_cms/controler/event.php/?index=26&id=${data.id}`,
                                //`http://localhost:8000/controler/event.php/?index=26&id=${data.id}`,
                                formData
                            );
                            successAlert("status updated")
                            getData();
                        } catch (error) {
                            errorAlert(error.response?.data?.message);
                        } finally {
                            setIsLoadingStatus(false)
                            setSelectedId(0)
                        }
                    }}
                />
            ),
        },
        { headerName: "Start Date", field: "start_date" },
        { headerName: "End Date", field: "end_date" },
        {
            headerName: "Action",
            cellRenderer: ({ data }) => (
                <Button.Group size="mini">
                    <Popup content="Edit" trigger={
                        <Button icon="edit" onClick={() => {
                            setEditData(data);
                            setShowModal(true);
                        }} />
                    } />
                    <Popup content="Delete" trigger={
                        <Button icon="trash" onClick={() => handleDelete(data.id)} />
                    } />
                </Button.Group>
            ),
        },
    ], []);

    return (
        loading ?
            <Dimmer active inverted>
                <Loader>Please Wait</Loader>
            </Dimmer>
            :
            <Container fluid>
                <Row className="my-3">
                    <Col><h3>Multiple Discount Management</h3></Col>
                    <Col className="text-end">
                        <Button icon="plus" color="blue" content="Add" onClick={() => setShowModal(true)} />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col>
                        <div className="d-flex justify-content-between align-items-center gap-3">
                            <DateRangePicker
                                value={dateRange}
                                onOk={setDateRange}
                                format="yyyy-MM-dd"
                            />

                            <div className="d-flex gap-2">
                                <Form.Control
                                    type="text"
                                    name="search"
                                    size="mini"
                                    placeholder="Search by code or target"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    style={{ maxWidth: "200px" }}
                                />
                                <Popup content={search.trim() === "" ? "Refresh" : "Search"} trigger={
                                    <Button
                                        variant="primary"
                                        color="orange"
                                        size="mini"
                                        icon={search.trim() === "" ? "refresh" : "search"}
                                        onClick={getData}
                                    >
                                    </Button>
                                } />
                            </div>

                        </div>
                    </Col>
                </Row>

                <Divider />

                {
                    ids.length > 1 && (
                        <Row className="mb-2">
                            <Col md="auto">
                                <Button
                                    color="red"
                                    icon="trash"
                                    loading={isLoadingDelete}
                                    onClick={() => handleDelete()}
                                    content="Delete Selected"
                                />
                            </Col>
                            {/* <Col md="auto">
                        <Form onSubmit={(e) => { e.preventDefault(); }}>
                            <Form.Select
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="">Select Status</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </Form.Select>
                            <Button
                                type="submit"
                                loading={isLoadingUpdate}
                                disabled={!selectedStatus}
                                content="Update Status"
                            />
                        </Form>
                    </Col> */}
                        </Row>
                    )
                }

                <div className="ag-theme-alpine" style={{ height: 500 }}>
                    <AgGridReact
                        rowData={data}
                        columnDefs={columnDefs}
                        rowSelection="multiple"
                        pagination
                        paginationPageSize={10}
                        onSelectionChanged={(p) => setSelectedRows(p.api.getSelectedRows())}
                        onGridReady={(p) => (gridApiRef.current = p.api)}
                    />
                </div>

                <Modal
                    show={showModal}
                    onHide={() => {
                        setShowModal(false);
                        setEditData(null);
                    }}
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {editData ? "Edit Multiple Discount" : "Add Multiple Discount"}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form onSubmit={handleSubmit}>

                            {/* TYPE & TARGET */}
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Discount Type</Form.Label>
                                        <Form.Select
                                            name="disc_type"
                                            value={discType}
                                            onChange={(e) => setDiscType(e.target.value)}
                                            required
                                        >
                                            <option value="1">Product</option>
                                            <option value="0">Categories</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Discount Target</Form.Label>

                                        {/* IF PRODUCT */}
                                        {discType === "1" && (
                                            <Form.Control
                                                name="disc_target"
                                                placeholder="Enter Product Code"
                                                defaultValue={editData?.disc_target || ""}
                                                required
                                            />
                                        )}

                                        {/* IF CATEGORY */}
                                        {discType === "0" && (
                                            <>
                                                <Dropdown
                                                    placeholder={loadingCategory ? "Loading..." : "Select Category"}
                                                    fluid
                                                    search
                                                    selection
                                                    disabled={loadingCategory}
                                                    options={categoryOptions}
                                                    value={selectedCategory}
                                                    onChange={(e, { value }) => setSelectedCategory(value)}
                                                />
                                                <Form.Control
                                                    type="hidden"
                                                    name="disc_target"
                                                    value={selectedCategory || ""}
                                                    required
                                                />
                                            </>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Discount Percentage (%)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="disc_percentage"
                                            min="1"
                                            max="100"
                                            placeholder="Enter percentage"
                                            defaultValue={editData?.disc_percentage || ""}
                                            required
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Maximum Quantity</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="maximum_qty"
                                            min="1"
                                            placeholder="Optional"
                                            defaultValue={editData?.maximum_qty || ""}
                                        />
                                        <Form.Text muted>
                                            Leave empty if unlimited
                                        </Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>

                            {/* DATE RANGE */}
                                <Row className="mb-3">
                                    <Col>
                                        <Form.Label>Active Date Range</Form.Label>
                                        <DateRangePicker
                                            className="w-100"
                                            format="yyyy-MM-dd"
                                            value={dateRangeActive}
                                            onOk={setDateRangeActive}
                                            placement="autoVerticalStart"
                                        />
                                    </Col>
                                </Row>

                            {editData && (
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select
                                                name="is_active"
                                                defaultValue={editData?.is_active || "1"}
                                            >
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            )}

                            <div className="text-end">
                                <Button
                                    type="button"
                                    color="black"
                                    onClick={() => {
                                        setShowModal(false);
                                        setEditData(null);
                                    }}
                                    content="Cancel"
                                />
                                <Button
                                    type="submit"
                                    color="orange"
                                    loading={isLoadingSubmit}
                                    className="ms-2"
                                    content="Save"
                                />
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
            </Container >
    );
};

export default MultipleDisc;